import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import { Box, PrimaryButton, Text, Slider, Loader } from '@stashinvest/ui';
import { SignUpStep } from 'stash/components/sign-up/SignUpScreenLayout';

import { patchRetireApplication } from 'stash/actions/api/investorApplication';
import { openDialog } from 'stash/actions/dialog';

const mapStateToProps = (state, ownProps) => {
	const retireQuestion = state.entities.investor_application.retire_question;

	return {
		isJointfiling: retireQuestion && retireQuestion.filing_type_key === 'joint',
		filing_status: state.entities.investor_application.filing_status,
		household_income_bracket:
			state.entities.investor_application.household_income_bracket,
		isUniversalReg: ownProps.product === 'universal',
	};
};

const mapDispatchToProps = (dispatch, ownProps) => ({
	getRetireQuestion: (filing_status) => {
		return dispatch(
			patchRetireApplication({
				investor_application: {
					filing_status,
				},
			})
		);
	},
	onSubmit: (values) => {
		return dispatch(
			patchRetireApplication({
				investor_application: { ...values },
			})
		)
			.then(() => {
				ownProps.completeStep();
			})
			.catch((e) => {
				dispatch(
					openDialog('Looks like there was a problem. Please try again.', 'Try again')
				).then(() => {
					window.location.reload();
				});
			});
	},
});

export class SignUpRetireHouseholdIncome extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			householdIncomeRanges: [],
			currentRangeIndex: null,
			isSubmitting: false,
		};

		this.handleCurrentStep = this.handleCurrentStep.bind(this);
		this.handleSubmit = this.handleSubmit.bind(this);
	}
	async componentDidMount() {
		const { filing_status, getRetireQuestion, household_income_bracket } = this.props;
		const defaultAnswerIndex = 2;

		const response = await getRetireQuestion(filing_status);
		const answerOptions = response.retire_question.answers;
		const normalizedAnswers = answerOptions
			.map((answer) => ({
				value: answer.key,
				label: answer.title,
				showLabel: false,
			}))
			.reverse();

		const currentAnswerIndex = household_income_bracket
			? normalizedAnswers.map((answer) => answer.value).indexOf(household_income_bracket)
			: defaultAnswerIndex;

		this.setState({
			householdIncomeRanges: normalizedAnswers,
			currentRangeIndex: currentAnswerIndex,
		});
	}
	handleCurrentStep(stepIndex) {
		this.setState({
			currentRangeIndex: stepIndex,
		});
	}
	handleSubmit() {
		const { currentRangeIndex, householdIncomeRanges } = this.state;
		const { onSubmit } = this.props;

		this.setState({ isSubmitting: true });
		onSubmit({
			household_income_bracket: householdIncomeRanges[currentRangeIndex].value,
		});
	}
	render() {
		const { currentRangeIndex, householdIncomeRanges, isSubmitting } = this.state;
		const { isJointfiling, isUniversalReg } = this.props;

		const incomeText = isJointfiling ? 'household' : '';
		const productText = isUniversalReg ? '' : 'retirement';
		const calculateText = isJointfiling
			? 'To calculate your household income, add your projected annual income and your spouse’s projected annual income.'
			: '';

		return (
			<SignUpStep>
				<Box>
					<Text.H1 size="3" mb="xxs">
						What will your {incomeText} income be this year?
					</Text.H1>
					<Box maxWidth="28rem" width="100%">
						<Text mb="m">
							We ask this to help determine what type of {productText} account is right
							for you. {calculateText}
						</Text>
						<Box data-testid="retirement-income" width="100%" mx="auto" mb="xs" p="xs">
							{householdIncomeRanges.length ? (
								<>
									<Text.H4 id="stash-ui-slider" align="center" pb="l">
										{householdIncomeRanges[currentRangeIndex].label}
									</Text.H4>
									<Slider
										aria-labelledby="stash-ui-slider"
										steps={householdIncomeRanges}
										defaultStepIndex={currentRangeIndex}
										handleCurrentStep={this.handleCurrentStep}
									/>
								</>
							) : (
								<Loader />
							)}
						</Box>
						<PrimaryButton
							type="submit"
							className="e2e-coach-btn"
							onClick={this.handleSubmit}
							disabled={isSubmitting}
						>
							Continue
						</PrimaryButton>
					</Box>
				</Box>
			</SignUpStep>
		);
	}
}

SignUpRetireHouseholdIncome.propTypes = {
	filing_status: PropTypes.string,
	household_income_bracket: PropTypes.string,
	getRetireQuestion: PropTypes.func,
	isUniversalReg: PropTypes.bool,
	isJointfiling: PropTypes.bool,
	onSubmit: PropTypes.func,
	completeStep: PropTypes.func,
};

export default connect(mapStateToProps, mapDispatchToProps)(SignUpRetireHouseholdIncome);
